import React, { useRef, useState } from "react";

export enum TechSupportType {
  CSS = "CSS",
  SME = "OLT SME Team",
}

export type HasbotContextType = {
  showDialog: boolean;
  setShowDialog: React.Dispatch<React.SetStateAction<boolean>>;
  techSupportActive?: TechSupportType;
  setZopimChatActive: React.Dispatch<React.SetStateAction<boolean>>;
  zopimChatActive: boolean;
  setTechSupportActive: React.Dispatch<React.SetStateAction<TechSupportType | undefined>>;
  openDialogBtnRef: React.RefObject<HTMLButtonElement>;
};

export const HasbotContext = React.createContext<HasbotContextType>({} as HasbotContextType);

export const HasbotProvider: React.FC<React.ReactNode> = ({ children }) => {
  // State
  const [showDialog, setShowDialog] = useState(false);
  const [zopimChatActive, setZopimChatActive] = useState(false);
  const [techSupportActive, setTechSupportActive] = useState<TechSupportType | undefined>();

  // Refs
  const openDialogBtnRef = useRef<HTMLButtonElement>(null);

  return (
    <HasbotContext.Provider
      value={{
        showDialog,
        setShowDialog,
        techSupportActive,
        setTechSupportActive,
        zopimChatActive,
        setZopimChatActive,
        openDialogBtnRef,
      }}
    >
      {children}
    </HasbotContext.Provider>
  );
};
